import React, { Component } from 'react';
import './style.scss';
import SaveIcon from '../../../../../_static/images/save.svg';
import DeleteIcon from '../../../../../_static/images/trash-alt.svg';

class TableUsers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      email: '',
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  

  handleSumbit = (e) => {
    e.preventDefault();
    this.props.newItem({...this.state});
    this.setState({name: '', email: ''});
  }

  render() {
    let {users, formatMessage, error_message, deleteItem, selectedEmail} = this.props;
    return (
      <div className="TableUsers">
        <form onSubmit={this.handleSumbit}>
          <table>
            <tr>
              <th>№</th>
              <th>{formatMessage('titleAddressBookEmail')}</th>
              <th>{formatMessage('titleAddressBookName')}</th>
              <th></th>
            </tr>
            {users.map((user, index) => <tr key={'user-item-' + index}>
              <td onClick={ () => {selectedEmail(user.email)}}>{index + 1}</td>
              <td onClick={ () => {selectedEmail(user.email)}}>{user.email}</td>
              <td onClick={ () => {selectedEmail(user.email)}}>{user.name}</td>
              <td><img onClick={() => {deleteItem(user.id)}} src={DeleteIcon} /></td>
            </tr>)}
            
            <tr className="new-address-user">
              
                <td></td>
                <td><input name='email' value={this.state.email} onChange={this.handleChange} type="email" required /></td>
                <td><input name='name' value={this.state.name} onChange={this.handleChange} required /></td>
                <td> <button><img src={SaveIcon} /></button></td>
              
            </tr>
          </table>
        </form>
        {error_message && <div className="col-xs-12 text-center text-danger">{error_message}</div>}
      </div>
    );
  }
}

export default TableUsers;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmUserBooks/components/TableUsers/index.jsx